import { NFCeConsultaDto } from "./../NFCe.Consulta.Dto";

const NFCeModalPropriedadesCode = (
  onCancel: () => void,
  onPrint: (value: NFCeConsultaDto) => void
) => {
  const onCancelClick = () => {
    onCancel();
  };
  const onPrintClick = (value: NFCeConsultaDto) => {
    onPrint(value);
  };
  return { onCancelClick, onPrintClick };
};

export default NFCeModalPropriedadesCode;
